import { GTMEvent } from '../GTM'
import { GTMProductData, isValidProductItemData } from './pushPdp'

type GTMPLPEvent = GTMEvent & {
    category?: string
    ecommerce?: {
        currencyCode: string
        impressions: GTMProductData[]
    }
}

export const isValidProductsDetails = (
    items: unknown
): items is GTMProductData[] => {
    if (!Array.isArray(items) || items.length === 0) {
        return false
    }
    let result = true
    items.forEach((item) => {
        if (!isValidProductItemData(item)) {
            result = false
        }
    })
    return result
}

export const pushPlp = (data: Record<string, unknown>): GTMEvent => {
    const { categoryName, currencyCode, productsDetails = [], type } = data

    const processedData: GTMPLPEvent = {
        event: type ? String(type) : 'category',
        category: String(categoryName),
        _clear: true
    }

    if (isValidProductsDetails(productsDetails)) {
        processedData['ecommerce'] = {
            currencyCode: String(currencyCode),
            impressions: productsDetails
        }
    }

    return processedData
}
